import React from 'react';

const VoteConfirmModal = ({
  open,
  title,
  selectedName,
  isSubmitting,
  onClose,
  onConfirm
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/55 px-3">
      <div className="w-full max-w-[560px] rounded-[12px] ring-[2px] ring-[#1B9938] bg-gradient-to-b from-[#d7e6da] to-[#d7e6da] p-0 shadow-[0_18px_36px_rgba(0,0,0,0.35)]">
        <div className="flex items-center justify-center border-b border-[#e5e7eb] px-5 py-4">
          <h3 className="text-[24px] font-semibold text-[#1f2937]">Xác nhận dự đoán: {title}</h3>
          {/* <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="h-[28px] w-[28px] rounded-[6px] border-0 bg-transparent text-[24px] leading-none text-[#7b7b7b] hover:bg-[#f3f4f6] disabled:opacity-50"
            aria-label="Đóng"
          >
            ×
          </button> */}
        </div>

        <div className="px-5 py-4">
          <div className="rounded-[8px] border border-[#d8dde4] bg-[#f7fafc] px-4 py-3">
            <div className="text-[14px] font-semibold uppercase text-[#111827]">Bạn đã chọn:</div>
            <div className="mt-1 text-[30px] font-bold leading-tight text-[#111827]">{selectedName}</div>
          </div>

          <div className="mt-4 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="h-[40px] min-w-[86px] rounded-[8px] border border-[#d1d5db] bg-[#f3f4f6] px-4 text-[16px] font-medium text-[#374151] disabled:opacity-50"
            >
              Hủy
            </button>
            <div className="rounded-[8px] bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px]">
              <button
                type="button"
                onClick={onConfirm}
                disabled={isSubmitting}
                className="h-[38px] min-w-[110px] rounded-[7px] border-0 bg-gradient-to-b from-[#00CD32] to-[#048724] px-4 text-[16px] font-semibold text-white shadow-[inset_0_-2px_0_#2CF65D] disabled:opacity-50"
              >
                {isSubmitting ? 'Đang gửi...' : 'Xác nhận'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoteConfirmModal;
